<template>
  <div class="footer-images">
    <div v-if="title" class="title mb-3">
      {{ title }}
    </div>
    <div class="content d-flex flex-wrap" v-bind:class="{ 'justify-content-center': center }">
      <slot></slot>
    </div>
  </div>
</template>


<script>
export default {
  name: "the-footer-images",
  props: {
    title: String,
    center: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


<style lang="scss" scoped>
.footer-images .title {
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;

  @include media-breakpoint-down(md) {
    text-align: center;
  }
}
</style>
